import { createBrowserHistory } from "history";

const createHistory = () => {
  return createBrowserHistory();
};

export default createHistory();
